import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDateFnsModule } from '@angular/material-date-fns-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { IconButtonModule } from '@core/buttons/icon-button/icon-button.module';
import { CalendarAvailabilityComponent } from './calendar-availability.component';
import { CalendarHeaderComponent } from './calendar-header/calendar-header.component';

@NgModule({
  imports: [CommonModule, IconButtonModule, MatDatepickerModule, MatDateFnsModule, MatIconModule, MatButtonModule],
  declarations: [CalendarAvailabilityComponent, CalendarHeaderComponent],
  exports: [CalendarAvailabilityComponent]
})
export class CalendarAvailabilityModule {}
